import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  sortBySelect: {
    width: 350
  }
}))
